export const GET_KLINE = '/market/p2p/kline';
export const RABEX_URL = process.env.NEXT_PUBLIC_RABEX_URL || '';
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || '';
export const P2P_WEBSOCKET = process.env.NEXT_PUBLIC_P2P_WEBSOCKET || '';
export const OTC_WEBSOCKET = process.env.NEXT_PUBLIC_OTC_WEBSOCKET || '';
export const BASE_URL_CHART = process.env.NEXT_PUBLIC_BASE_URL_CHART || '';
export const BASE_URL_LOGO = process.env.NEXT_PUBLIC_BASE_URL_LOGO || '';
